import AuthApi from "./AuthApi";
import BaseApi from "./BaseApi";

export const Api={
    BaseApi,AuthApi
}